import {integrationDocumentationModule} from "./integrationDocumentationModule";

export interface IntegrationDocumentationUrls {
    "web-services": string
}

export class IntegrationDocumentationUrlsProvider {
    private urls = {};

    setUrls(urls: IntegrationDocumentationUrls) {
        this.urls = urls;
    }

    $get() {
        return this.urls;
    }
}

integrationDocumentationModule.provider("integrationDocumentationUrls", IntegrationDocumentationUrlsProvider)